import { useEffect, useState } from "react";
import { PRODUCTS, waLink } from "../data/site";
import { fetchProducts, imageSrc } from "../lib/api";

export const Products = () => {
  const [products, setProducts] = useState(PRODUCTS);

  useEffect(() => {
    fetchProducts()
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) setProducts(data);
      })
      .catch(() => {
        // In caso di errore restano i capi predefiniti
      });
  }, []);

  return (
    <section id="vetrina" data-testid="products-section" className="py-24 max-w-6xl mx-auto px-6">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.16em] text-cognac font-semibold mb-2">
            Vetrina &amp; Disponibilità
          </p>
          <h2 className="font-display sec-title font-normal text-ink">Capi in primo piano</h2>
        </div>
        <p className="text-sm text-ink/70 max-w-sm">
          Chiedici subito prezzi, misure e vestibilità via chat.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products.map((p) => (
          <div key={p.id} data-testid={`product-card-${p.id}`} className="d1-card group flex flex-col">
            <div className="aspect-[3/4] rounded-xl overflow-hidden relative mb-4 border border-ink/10 bg-cream">
              <img
                src={imageSrc(p.image)}
                alt={p.alt || p.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div
                data-testid={`product-price-${p.id}`}
                className="absolute top-3 right-3 bg-white/90 backdrop-blur text-xs px-2.5 py-1 rounded-full font-medium"
              >
                {p.price}
              </div>
            </div>
            <h3 className="font-display text-lg font-semibold">{p.title}</h3>
            <p className="text-xs text-ink/70 mb-3">{p.sizes}</p>
            <a
              href={waLink(`Ciao! Mi interessa "${p.title}" (${p.price}). È disponibile? Che taglie avete?`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-cta-${p.id}`}
              className="mt-auto inline-flex items-center justify-between text-xs font-semibold uppercase tracking-wider text-cognac group-hover:text-ink transition-colors"
            >
              <span>Chiedi disponibilità</span>
              <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
